import React from "react";
const TechnologyContext = React.createContext();
export default TechnologyContext;